import React, { useMemo } from "react";
import { Stack } from "@mui/material";
import { shuffle } from "@smartrr/shared/utils/shuffle";
import { DotSpinner } from "@smartrr/shared/customerPortal/components/DotSpinner";
import { useSmartrrCustomerSelector } from "@smartrr/customer-portal/src/_state/typedCustomerReduxHooks";
import PauseReasonPickerItems from "./PauseReasonPickerItems";
import type { IPauseReason } from "@smartrr/shared/entities/CancellationRelationship";

interface IPauseReasonPickerProps {
  selectedPauseReason: IPauseReason | undefined;
  setSelectedPauseReason: (reason: IPauseReason) => void;
  userPauseReasonText: string | undefined;
  setUserPauseReasonText: (text: string) => void;
  placeholderText?: string;
}

export default function PauseReasonPicker({
  selectedPauseReason,
  setSelectedPauseReason,
  userPauseReasonText,
  setUserPauseReasonText,
  placeholderText,
}: IPauseReasonPickerProps) {
  const { pauseReasons, isLoading } = useSmartrrCustomerSelector(state => state.retention);

  const shuffledReasons = useMemo(() => {
    return shuffle(pauseReasons);
  }, [pauseReasons]);

  if (isLoading) {
    return (
      <Stack justifyContent="center" alignItems="center">
        <DotSpinner />
      </Stack>
    );
  }

  return (
    <PauseReasonPickerItems
      reasons={shuffledReasons}
      selectedPauseReason={selectedPauseReason}
      setSelectedPauseReason={setSelectedPauseReason}
      userPauseReasonText={userPauseReasonText}
      setUserPauseReasonText={setUserPauseReasonText}
      placeholderText={placeholderText}
    />
  );
}
